(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cleora-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cleora-product]').forEach((section) => {
    const mediaCarousel = section.querySelector('.cleora-product__main-media');
    const mediaDotsWrap = section.querySelector('[data-media-dots]');
    if (mediaCarousel && mediaDotsWrap) {
      const mediaItems = [...mediaCarousel.querySelectorAll('.cleora-product__media-item')];
      const mediaDots = [...mediaDotsWrap.querySelectorAll('.cleora-product__dot')];
      if (mediaItems.length > 1 && mediaItems.length === mediaDots.length) {
        const mediaObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = mediaItems.indexOf(entry.target);
            if (index === -1) return;
            mediaDots.forEach((dot, dotIndex) => {
              if (dotIndex === index) {
                dot.setAttribute('data-active', '');
              } else {
                dot.removeAttribute('data-active');
              }
            });
          });
        }, { root: mediaCarousel, threshold: 0.6 });
        mediaItems.forEach((item) => mediaObserver.observe(item));
      }
    }

    const sizeGuideButton = section.querySelector('[data-size-guide-open]');
    const sizeGuideDialog = section.querySelector('[data-size-guide-dialog]');
    if (sizeGuideButton && sizeGuideDialog) {
      const sizeGuideClose = sizeGuideDialog.querySelector('[data-size-guide-close]');
      let sizeGuideLastFocus;
      const closeSizeGuide = () => {
        if (typeof sizeGuideDialog.close === 'function' && sizeGuideDialog.open) {
          sizeGuideDialog.close();
        } else {
          sizeGuideDialog.removeAttribute('open');
          sizeGuideDialog.classList.remove('cleora-size-dialog-fallback');
        }
        document.documentElement.classList.remove('cleora-size-dialog-open');
        sizeGuideLastFocus?.focus();
      };
      sizeGuideButton.addEventListener('click', () => {
        sizeGuideLastFocus = document.activeElement;
        if (typeof sizeGuideDialog.showModal === 'function') {
          sizeGuideDialog.showModal();
        } else {
          sizeGuideDialog.setAttribute('open', '');
          sizeGuideDialog.classList.add('cleora-size-dialog-fallback');
        }
        document.documentElement.classList.add('cleora-size-dialog-open');
        sizeGuideClose?.focus();
      });
      sizeGuideClose?.addEventListener('click', closeSizeGuide);
      sizeGuideDialog.addEventListener('click', (event) => {
        if (event.target === sizeGuideDialog) closeSizeGuide();
      });
      sizeGuideDialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeSizeGuide();
      });
      sizeGuideDialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cleora-size-dialog-open');
      });
    }

    const form = section.querySelector('.cleora-product-form');
    const data = section.querySelector('[data-product-variants]');
    if (!form || !data) return;
    const variants = JSON.parse(data.textContent);
    const idInput = form.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-product-compare]');
    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = form.querySelector('[data-add-text]');
    const currency = section.dataset.currency || 'EUR';
    const formatMoney = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(cents / 100);
    form.addEventListener('change', () => {
      const selected = [...form.querySelectorAll('fieldset')].map((field) => field.querySelector('input:checked')?.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      idInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.textContent = formatMoney(variant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
      button.disabled = !variant.available;
      buttonText.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
